var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { Icon } from '@iconify/react';
var SideBarIcon = function (_a) {
    var _b = _a.iconName, iconName = _b === void 0 ? '' : _b, iconSize = _a.iconSize, iconColor = _a.iconColor, iconMargin = _a.iconMargin, onClick = _a.onClick;
    return (_jsx(Container, __assign({ iconMargin: iconMargin, onClick: onClick }, { children: _jsx(Icon, { icon: iconName, fontSize: iconSize, color: iconColor }) })));
};
export default SideBarIcon;
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  margin: ", ";\n  border: 0px;\n  &:hover {\n    scale: calc(1.05);\n  }\n"], ["\n  cursor: pointer;\n  margin: ", ";\n  border: 0px;\n  &:hover {\n    scale: calc(1.05);\n  }\n"])), function (_a) {
    var iconMargin = _a.iconMargin;
    return iconMargin !== null && iconMargin !== void 0 ? iconMargin : '0px 12px 0px 24px';
});
var templateObject_1;
